import { render, staticRenderFns } from "./personaje-icon-2.vue?vue&type=template&id=181b18aa&scoped=true&"
import script from "./personaje-icon-2.vue?vue&type=script&lang=js&"
export * from "./personaje-icon-2.vue?vue&type=script&lang=js&"
import style0 from "./personaje-icon-2.vue?vue&type=style&index=0&id=181b18aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b18aa",
  null
  
)

export default component.exports